import {
  GET_WORKSTATION_POSITIONS_STATUS,
  GET_WORKSTATION_POSITIONS_STATUS_SUCCESS,
  GET_WORKSTATION_POSITIONS_STATUS_ERROR,
} from './actionTypes';

export const getWorkstationPositionsStatus = (user) => {
  return {
    type: GET_WORKSTATION_POSITIONS_STATUS,
    payload: { user },
  };
};

export const getWorkstationPositionsStatusSuccess = (positions, message) => {
  return {
    type: GET_WORKSTATION_POSITIONS_STATUS_SUCCESS,
    payload: { positions, message },
  };
};

export const getWorkstationPositionsStatusError = (msg) => {
  return {
    type: GET_WORKSTATION_POSITIONS_STATUS_ERROR,
    payload: msg,
  };
};
